import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"
import { showToast } from "../utils/show_toast"
import { csrfToken } from "../utils/csrf_token"

// Generic single-list drag-to-reorder that PATCHes the ordered ids of
// `[data-sortable-id]` children to a reorder endpoint.
export default class extends Controller {
  static values = { reorderUrl: String }
  static targets = ["list"]

  connect() {
    this.list = this.hasListTarget ? this.listTarget : this.element
    this.sortable = Sortable.create(this.list, {
      handle: ".sortable-handle",
      animation: 150,
      ghostClass: "opacity-50",
      draggable: "[data-sortable-id]",
      onEnd: () => this.persist()
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  persist() {
    const orderedIds = Array.from(this.list.querySelectorAll("[data-sortable-id]"))
      .map((el) => el.dataset.sortableId)

    fetch(this.reorderUrlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": csrfToken(),
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({ ordered_ids: orderedIds })
    }).then((response) => {
      if (!response.ok) throw new Error("reorder failed")
    }).catch(() => {
      showToast("Couldn't save the new order", "error")
    })
  }
}
